module.exports = "<div class=\"hover-tooltip-wrap\" ng-mouseover=\"$ctrl.hoverIn()\" ng-mouseleave=\"$ctrl.hoverOut()\">\n    <div ng-transclude=\"content\"></div>\n    <div ng-transclude=\"message\" ng-class=\"['tooltip-msg', {opened: $ctrl.itemHovered}]\"></div>\n</div>\n<!-- .hover-tooltip-wrap END -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpHoverTooltip/adpHoverTooltip.html
// module id = 633
// module chunks = 0